import { DashboardChip } from "./DashboardChip";
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';

interface InspectionPassedChipProps {
    onClick?: () => void;
    isDeactivated?: boolean;
}

export const InspectionPassedChip = ({ onClick, isDeactivated }: InspectionPassedChipProps) => {
    return (
        <DashboardChip
            text={<DoneOutlinedIcon fontSize="small" />}
            icon={<SearchIcon />}
            backgroundColor="#4DB749"
            borderColor="#178315"
            onClick={onClick}
            isDeactivated={isDeactivated}
        />
    )
};